// extracted by mini-css-extract-plugin
export default {"wallet":"Wallet_wallet__pSNiL","balance":"Wallet_balance__I8dga","currency":"Wallet_currency__zUQYt"};